import { render, staticRenderFns } from "./attrOper.vue?vue&type=template&id=47a46568&scoped=true"
import script from "./attrOper.vue?vue&type=script&lang=js"
export * from "./attrOper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a46568",
  null
  
)

export default component.exports